<div class="quantity-wrapper">
  <div
    class="quantity"
    [class.quantity--error]="shouldShowErrors() && getPrimaryError()"
    [class.quantity--disabled]="disabled"
  >
    <div class="quantity__segment quantity__segment--button">
      <button
        type="button"
        mat-button
        color="accent"
        class="quantity__btn"
        [disabled]="decrementDisabled()"
        (click)="decrement()"
        aria-label="Decrease quantity"
      >
        −
      </button>
    </div>
    <div class="quantity__segment quantity__segment--input">
      <input
        matInput
        class="quantity__input"
        [id]="inputId"
        type="text"
        role="spinbutton"
        inputmode="decimal"
        autocomplete="off"
        [formControl]="inputFc"
        [readonly]="enforceStep"
        (blur)="onBlur()"
        (keydown)="onKeyDown($event)"
        (paste)="onPaste($event)"
        [attr.aria-disabled]="disabled"
        [attr.aria-label]="ariaLabel"
        [attr.aria-valuenow]="ariaValueNow"
        [attr.aria-valuemin]="ariaMin"
        [attr.aria-valuemax]="ariaMax"
      />
    </div>
    <div class="quantity__segment quantity__segment--button">
      <button
        type="button"
        mat-button
        color="accent"
        class="quantity__btn"
        [disabled]="incrementDisabled()"
        (click)="increment()"
        aria-label="Increase quantity"
      >
        +
      </button>
    </div>
  </div>
  @if (getPrimaryError()) {
    <div class="quantity__error" role="alert">{{ getPrimaryError() }}</div>
  }
</div>
